import React from "react";
//#region redux
//#endregion
//#region types
import { SelfInvoiceFilePreviewProps } from "models/propTypes/selfInvoicePropTypes";
//#endregion
//#region components
import { FileViewerContainer } from "components/common";
//#endregion

const SelfInvoiceFileViewer: React.FC<SelfInvoiceFilePreviewProps> = ({ invoice }) => {
  return (
    <FileViewerContainer
      key={invoice?.id}
      meta={invoice?.images?.map((meta) => ({
        id: meta.id ?? "",
        contentType: meta.contentType ?? "",
        numberOfPages: 1,
        data: meta.content,
      }))}
      parentId={invoice?.id ?? 0}
      loading={invoice === undefined}
    />
  );
};

export default SelfInvoiceFileViewer;
